"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const measure_model_1 = require("../../../shared/model/measure.model");
const chart_sort_type_model_1 = require("../../categorical-chart/shared/chart-sort-type.model");
const Subject_1 = require("rxjs/Subject");
const idm_reporting_service_client_js_1 = require("@synisys/idm-reporting-service-client-js");
const multilingual_type_helper_1 = require("../../../../shared/multilingual-type-helper");
class CombinationChartModel {
    constructor() {
        this._selectedPaletteId = 0;
        this._category = null;
        this._series = null;
        this._columnMeasures = [];
        this._lineMeasures = [];
        this._categoriesTop = 10;
        this._seriesTop = 10;
        this._filter = idm_reporting_service_client_js_1.FilterDtoBuilder.createOrFilterBuilder().build();
        this._pages = [];
        this._chartSortType = chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING;
        this._excludeUnspecified = false;
        this._isMeasureAxisZoomSlicerVisible = false;
        this._isCategoryAxisZoomSlicerVisible = false;
        this._chartModelSubject = new Subject_1.Subject();
    }
    get selectedPaletteId() {
        return this._selectedPaletteId;
    }
    set selectedPaletteId(value) {
        this._selectedPaletteId = value;
        this._chartModelSubject.next();
    }
    get category() {
        return this._category;
    }
    set category(value) {
        this._category = value;
        this._chartModelSubject.next();
    }
    setCategory(value) {
        this._category = value;
    }
    get series() {
        return this._series;
    }
    set series(value) {
        this._series = value;
        this._chartModelSubject.next();
    }
    setSeries(value) {
        this._series = value;
    }
    get columnMeasures() {
        return this._columnMeasures;
    }
    set columnMeasures(value) {
        this._columnMeasures = value;
        this._chartModelSubject.next();
    }
    get lineMeasures() {
        return this._lineMeasures;
    }
    set lineMeasures(value) {
        this._lineMeasures = value;
        this._chartModelSubject.next();
    }
    get categoriesTop() {
        return this._categoriesTop;
    }
    set categoriesTop(value) {
        this._categoriesTop = value;
        this._chartModelSubject.next();
    }
    get seriesTop() {
        return this._seriesTop;
    }
    set seriesTop(value) {
        this._seriesTop = value;
        this._chartModelSubject.next();
    }
    get chartSortType() {
        return this._chartSortType;
    }
    set chartSortType(value) {
        this._chartSortType = value;
        this._chartModelSubject.next();
    }
    setChartSortType(chartSortType) {
        this._chartSortType = chartSortType;
    }
    get filter() {
        return this._filter;
    }
    set filter(value) {
        this._filter = value;
        this._chartModelSubject.next();
    }
    get pages() {
        return this._pages;
    }
    set pages(value) {
        this._pages = value;
        this._chartModelSubject.next();
    }
    get isDataLabelsShowed() {
        return this._isDataLabelsShowed;
    }
    set isDataLabelsShowed(value) {
        this._isDataLabelsShowed = value;
        this._chartModelSubject.next();
    }
    get valueAxisTitle() {
        return this._valueAxisTitle;
    }
    set valueAxisTitle(value) {
        this._valueAxisTitle = value;
        this._chartModelSubject.next();
    }
    get categoryAxisTitle() {
        return this._categoryAxisTitle;
    }
    set categoryAxisTitle(value) {
        this._categoryAxisTitle = value;
        this._chartModelSubject.next();
    }
    get excludeUnspecified() {
        return this._excludeUnspecified;
    }
    set excludeUnspecified(excludeUnspecified) {
        this._excludeUnspecified = excludeUnspecified;
    }
    get isMeasureAxisZoomSlicerVisible() {
        return this._isMeasureAxisZoomSlicerVisible;
    }
    set isMeasureAxisZoomSlicerVisible(value) {
        this._isMeasureAxisZoomSlicerVisible = value;
        this._chartModelSubject.next();
    }
    get isCategoryAxisZoomSlicerVisible() {
        return this._isCategoryAxisZoomSlicerVisible;
    }
    set isCategoryAxisZoomSlicerVisible(value) {
        this._isCategoryAxisZoomSlicerVisible = value;
        this._chartModelSubject.next();
    }
    getChartModelSubject() {
        return this._chartModelSubject.asObservable();
    }
    toJsonString() {
        let jsonObject = {};
        jsonObject.category = this.category;
        jsonObject.series = this.series;
        jsonObject.columnMeasures = this.columnMeasures;
        jsonObject.lineMeasures = this.lineMeasures;
        jsonObject.chartSortType = this.chartSortType;
        jsonObject.categoriesTop = this.categoriesTop;
        jsonObject.seriesTop = this.seriesTop;
        jsonObject.pages = this.pages;
        jsonObject.selectedPaletteId = this.selectedPaletteId;
        jsonObject.filter = this.filter.toJson();
        jsonObject.isDataLabelsShowed = this.isDataLabelsShowed;
        jsonObject.valueAxisTitle = multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.valueAxisTitle);
        jsonObject.categoryAxisTitle = multilingual_type_helper_1.MultilingualTypeHelper.serializeMultilingualString(this.categoryAxisTitle);
        jsonObject.excludeUnspecified = this.excludeUnspecified;
        jsonObject.isMeasureAxisZoomSlicerVisible = this.isMeasureAxisZoomSlicerVisible;
        jsonObject.isCategoryAxisZoomSlicerVisible = this.isCategoryAxisZoomSlicerVisible;
        return JSON.stringify(jsonObject);
    }
    fromJson(jsonString) {
        if (jsonString !== "" && jsonString !== null) {
            let jsonObject = JSON.parse(jsonString);
            this._category = jsonObject.category === undefined ? null : jsonObject.category;
            this._series = jsonObject.series === undefined ? null : jsonObject.series;
            this._columnMeasures = jsonObject.columnMeasures == undefined ? null :
                jsonObject.columnMeasures
                    .map(measure => measure_model_1.MeasureModel.fromJSON(measure));
            this._lineMeasures = jsonObject.lineMeasures == undefined ? null :
                jsonObject.lineMeasures
                    .map(measure => measure_model_1.MeasureModel.fromJSON(measure));
            this._chartSortType = jsonObject.chartSortType == null ? chart_sort_type_model_1.ChartSortType.CATEGORY_ASCENDING : jsonObject.chartSortType;
            this._categoriesTop = jsonObject.categoriesTop === undefined ? 10 : jsonObject.categoriesTop;
            this._seriesTop = jsonObject.seriesTop === undefined ? (jsonObject.top === undefined ? 10 : jsonObject.top) : jsonObject.seriesTop;
            this._selectedPaletteId = jsonObject.selectedPaletteId || 0;
            this._filter = jsonObject.filter ? idm_reporting_service_client_js_1.FilterTreeDto.fromJson(jsonObject.filter) : idm_reporting_service_client_js_1.FilterDtoBuilder.createOrFilterBuilder().build();
            this._pages = jsonObject.pages == undefined ? null : jsonObject.pages;
            this._isDataLabelsShowed = jsonObject.isDataLabelsShowed || false;
            this._valueAxisTitle = jsonObject.valueAxisTitle && multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.valueAxisTitle);
            this._categoryAxisTitle = jsonObject.categoryAxisTitle && multilingual_type_helper_1.MultilingualTypeHelper.deserializeMultilingualString(jsonObject.categoryAxisTitle);
            this._excludeUnspecified = jsonObject.excludeUnspecified === undefined ? false : jsonObject.excludeUnspecified;
            this._isMeasureAxisZoomSlicerVisible = jsonObject.isMeasureAxisZoomSlicerVisible === undefined ? false : jsonObject.isMeasureAxisZoomSlicerVisible;
            this._isCategoryAxisZoomSlicerVisible = jsonObject.isCategoryAxisZoomSlicerVisible === undefined ? false : jsonObject.isCategoryAxisZoomSlicerVisible;
        }
    }
    /**
     * These method check if generated report is valid
     * @returns {boolean}
     */
    validateReport() {
        return (this._category !== null && ((this._columnMeasures !== null && this._columnMeasures.length > 0)
            || (this._lineMeasures !== null && this._lineMeasures.length > 0)));
    }
}
exports.CombinationChartModel = CombinationChartModel;
//# sourceMappingURL=combination-chart.model.js.map